export class LoadingReportSave {
    LoadingCommencedDateUTC;
    LoadingCompletedDateUTC;
    VesselDepartedDateUTC;
    LivestockLoadedEdit; // array
    LivestockLoadedNew; // array
    FeedROB;// object
    FeedLoaded; // array of objects

    constructor(loadingCommencedDate, loadingCompletedDate, vesselDepartureDate, livestockLoadedEdit, livestockLoadedAddition, feedROB, feedLoaded) {
        this.LoadingCommencedDateUTC = loadingCommencedDate;
        this.LoadingCompletedDateUTC = loadingCompletedDate;
        this.VesselDepartedDateUTC = vesselDepartureDate;
        this.LivestockLoadedEdit = livestockLoadedEdit;
        this.LivestockLoadedAddition = livestockLoadedAddition;
        this.FeedROB = feedROB;
        this.FeedLoaded = feedLoaded;
    }
}

export class LoadingReportLivestockLoadedEdit{
    ID;
    NumberLoaded;

    constructor(id, numberLoaded) {
        this.ID = id;
        this.NumberLoaded = numberLoaded;
    }
}

export class LoadingReportLivestockLoadedAddition{
    ID;
    NumberLoaded;

    constructor(numberLoaded, speciesID, classID) {
        this.NumberLoaded = numberLoaded;
        this.SpeciesID = speciesID;
        this.ClassID = classID;
    }
}